'use strict';

import { CoreRepository } from '../CoreRepository';
import { AutomationAction } from '../../Entities/Automation/AutomationAction';
import { AutomationActionCollection } from '../../Collections/Automation/AutomationActionCollection';

export class AutomationActionRepository extends CoreRepository {
  public getAutomationActions(userId: number, automationId: number, options = {}) {
    return this.webAPI.getAutomationActions(userId, automationId, options).then((response) => {
      const collection = new AutomationActionCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new AutomationAction();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public updateAutomationAction(
    userId: number,
    automationId: number,
    automationActionId: number,
    payload: any
  ) {
    return this.webAPI
      .updateAutomationAction(userId, automationId, automationActionId, payload)
      .then((response) => {
        const item = new AutomationAction();
        item.hydrate(response);
        return item;
      });
  }

  public createAutomationAction(userId: number, automationId: number, payload: any) {
    return this.webAPI.createAutomationAction(userId, automationId, payload).then((response) => {
      const item = new AutomationAction();
      item.hydrate(response);
      return item;
    });
  }

  public deleteAutomationAction(userId: number, automationId: number, automationActionId: number) {
    return this.webAPI
      .deleteAutomationAction(userId, automationId, automationActionId)
      .then((response) => {
        return response;
      });
  }
}
